import { useEffect, useRef } from "react";

const H = 180, G = 142;
let W = 320;
const R = (c, col, x, y, w, h) => { c.fillStyle = col; c.fillRect(Math.round(x), Math.round(y), w, h); };
const FLAKES = Array.from({ length: 260 }, (_, i) => [(i * 97.31) % 640, (i * 53.7) % H, 0.4 + (i % 3) * 0.3]);
const STARS = Array.from({ length: 100 }, (_, i) => [(i * 61.7) % 640, (i * 23.3) % 70]);

function pine(c, x, y, s) {
  R(c, "#05080f", x + 3 * s, y + 18 * s, 2 * s, 6 * s);
  for (let k = 0; k < 4; k++) R(c, "#070c16", x + 4 * s - (2 + k * 2) * s, y + k * 5 * s, (4 + k * 4) * s, 6 * s);
  R(c, "#c8d6e3", x + 2 * s, y, 4 * s, 1); R(c, "#c8d6e3", x - 2 * s, y + 15 * s, 4 * s, 1);
}

function cabin(c, x, t) {
  R(c, "#1e150d", x, G - 34, 70, 34); for (let y = G - 31; y < G; y += 4) R(c, "#140e08", x, y, 70, 1);
  for (let i = 0; i < 9; i++) R(c, "#1e150d", x - 5 + i * 3, G - 34 - i * 3, 80 - i * 6, 3);
  R(c, "#d9e4ee", x - 7, G - 36, 84, 3); R(c, "#d9e4ee", x + 16, G - 60, 38, 3);
  R(c, "#2a1a10", x + 52, G - 62, 7, 16); R(c, "#d9e4ee", x + 51, G - 63, 9, 2);
  for (let i = 0; i < 6; i++) R(c, `rgba(120,130,145,${0.35 - i * 0.05})`, x + 53 + Math.sin(t / 800 + i) * 3 - i, G - 68 - i * 6 - ((t / 70) % 6), 4, 4);
  const blink = Math.sin(t / 3100) > 0.96;
  [[x + 9, G - 24], [x + 49, G - 24]].forEach(([wx, wy], i) => {
    const lit = !(blink && i === 0), f = 0.85 + Math.sin(t / 130 + i) * 0.15;
    R(c, lit ? `rgba(245,158,11,${f})` : "#2b1c0b", wx, wy, 12, 10); R(c, "#140e08", wx + 5, wy, 2, 10); R(c, "#140e08", wx, wy + 4, 12, 2);
    if (lit) R(c, "rgba(245,158,11,0.12)", wx - 6, G, 24, 6);
  });
  R(c, "#3a2414", x + 29, G - 20, 11, 20); R(c, "#f59e0b", x + 37, G - 11, 1, 1);
}

function watcher(c, t, x) {
  const cyc = (t / 1000) % 14;
  if (cyc < 9) return;
  const a = cyc < 9.8 ? (cyc - 9) / 0.8 : cyc > 13 ? 14 - cyc : 1;
  R(c, `rgba(92,15,15,${a})`, x, G - 17, 5, 14); R(c, `rgba(127,29,29,${a})`, x + 1, G - 17, 3, 14);
  R(c, `rgba(92,15,15,${a})`, x + 1, G - 21, 3, 5); R(c, `rgba(5,2,3,${a})`, x + 2, G - 19, 1, 2);
}

function draw(c, t) {
  ["#03050b", "#050914", "#080e1c", "#0b1324"].forEach((col, i) => R(c, col, 0, i * 30, W, 30));
  STARS.forEach(([x, y], i) => Math.sin(t / 600 + i) > -0.4 && R(c, "#a9bbcc", x, y, 1, 1));
  const mx = W * 0.82;
  for (let y = -6; y <= 6; y++) { const h = Math.round(Math.sqrt(36 - y * y)); R(c, "#cfd8e3", mx - h, 28 + y, h * 2, 1); }
  for (let y = -6; y <= 6; y++) { const h = Math.round(Math.sqrt(36 - y * y)); R(c, "#050914", mx - h + 4, 26 + y, h * 2, 1); }
  for (let s = 0; s < W / 3; s++) R(c, "#0b1424", s * 3, 64 + Math.abs(((s * 2.2) % 80) - 40) * 0.9, 3, H);
  for (let s = 0; s < W / 3; s++) R(c, "#0e192b", s * 3, 92 + Math.abs(((s * 1.6 + 30) % 60) - 30) * 0.6, 3, H);
  const cx = Math.round(W * 0.52);
  for (let x = 4, i = 0; x < W; x += 15 + (i % 3) * 4, i++) if (Math.abs(x - cx - 30) > 52) pine(c, x, G - 26 - (i % 3) * 4, 1);
  watcher(c, t, cx - 34);
  cabin(c, cx, t);
  R(c, "#c8d6e3", 0, G, W, H - G); R(c, "#8ea4bb", 0, G, W, 1);
  for (let i = 0; i < 12; i++) R(c, "#9fb3c7", 184 + i * 3 - i * i * 0.4, G + 4 + i * 3, 2, 1);
  pine(c, W * 0.03, G - 40, 2); pine(c, W - 34, G - 44, 2);
  FLAKES.forEach(([x, y, v]) => R(c, "#e8f1ff", (x + Math.sin(t / 900 + y) * 6 + t * 0.004 * v) % W, (y + t * 0.02 * v) % H, 1, 1));
}

export const LandingScene = () => {
  const ref = useRef(null);
  useEffect(() => {
    const cv = ref.current, c = cv.getContext("2d"); let raf;
    const fit = () => { W = Math.min(640, Math.max(200, Math.round(H * (cv.clientWidth / cv.clientHeight)))); cv.width = W; cv.height = H; };
    fit(); window.addEventListener("resize", fit);
    const loop = (t) => { draw(c, t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", fit); };
  }, []);
  return <canvas ref={ref} className="absolute inset-0 w-full h-full object-cover" style={{ imageRendering: "pixelated" }} data-testid="landing-scene" />;
};
